var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import styles from '../../@patternfly/patternfly-next/components/Dropdown/dropdown.css.js';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import { KEY_CODES } from '../../internal/constants';

var propTypes = {
  /** HTML ID of dropdown toggle */
  id: PropTypes.string.isRequired,
  /** Anything which can be rendered as dropdown toggle */
  children: PropTypes.node,
  /** Classes applied to root element of dropdown toggle */
  className: PropTypes.string,
  /** Flag to indicate if menu is opened */
  isOpen: PropTypes.bool,
  /** Callback called when toggle is clicked */
  onToggle: PropTypes.func,
  /** Element which wraps toggle */
  parentRef: PropTypes.any,
  /** Forces focus state */
  isFocused: PropTypes.bool,
  /** Forces hover state */
  isHovered: PropTypes.bool,
  /** Forces active state */
  isActive: PropTypes.bool
};

var defaultProps = {
  children: null,
  className: '',
  isOpen: false,
  parentRef: null,
  isFocused: false,
  isHovered: false,
  isActive: false,
  onToggle: Function.prototype
};

var DropdownToggle = function (_Component) {
  _inherits(DropdownToggle, _Component);

  function DropdownToggle() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DropdownToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropdownToggle.__proto__ || Object.getPrototypeOf(DropdownToggle)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      document.addEventListener('mousedown', _this.onDocClick);
      document.addEventListener('keydown', _this.onEscPress);
    }, _this.componentWillUnmount = function () {
      document.removeEventListener('mousedown', _this.onDocClick);
      document.removeEventListener('keydown', _this.onEscPress);
    }, _this.onDocClick = function (event) {
      if (_this.props.parentRef && !_this.props.parentRef.contains(event.target)) {
        _this.props.onToggle && _this.props.onToggle(false);
      }
    }, _this.onEscPress = function (event) {
      var parentRef = _this.props.parentRef;

      var keyCode = event.keyCode || event.which;
      if (keyCode === KEY_CODES.ESCAPE_KEY && parentRef && parentRef.contains(event.target)) {
        _this.props.onToggle && _this.props.onToggle(false);
        _this.toggle.focus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropdownToggle, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isOpen = _props.isOpen,
          isFocused = _props.isFocused,
          isActive = _props.isActive,
          isHovered = _props.isHovered,
          onToggle = _props.onToggle,
          parentRef = _props.parentRef,
          id = _props.id,
          props = _objectWithoutProperties(_props, ['className', 'children', 'isOpen', 'isFocused', 'isActive', 'isHovered', 'onToggle', 'parentRef', 'id']);

      return React.createElement(
        'button',
        _extends({}, props, {
          id: id,
          ref: function ref(toggle) {
            _this2.toggle = toggle;
          },
          className: css(styles.dropdownToggle, isFocused && styles.modifiers.focus, isHovered && styles.modifiers.hover, isActive && styles.modifiers.active, className),
          onClick: function onClick(_event) {
            return onToggle && onToggle(!isOpen);
          },
          'aria-expanded': isOpen
        }),
        children
      );
    }
  }]);

  return DropdownToggle;
}(Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

export default DropdownToggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Dropdown/Toggle.js
// module id = 109
// module chunks = 0